(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kona-package-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kona-package-builder')) {
  customElements.define('kona-package-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-kp-data]').textContent);
      this.words = this.data.words;
      const decoder = document.createElement('textarea');
      const decode = value => { decoder.innerHTML = value; return decoder.value; };
      Object.keys(this.words).forEach(key => this.words[key] = decode(this.words[key]));
      this.products = this.data.products.filter(p => p.product && p.product.id);
      this.products.forEach(p => { p.label = decode(p.label); p.description = decode(p.description); });
      this.rules = this.data.rules;
      this.shape = this.products.find(p => p.kind === 'pool')?.key;
      this.pool = null;
      this.pump = null;
      this.extras = new Map();
      this.variants = new Map();
      this.products.forEach(p => p.product.variants.forEach(v => this.variants.set(String(v.id), { ...v, source: p })));
      const entry = new URLSearchParams(location.search);
      const entryProduct = this.products.find(p => p.kind === 'pool' && p.product.handle === entry.get('pool'));
      const entryVariant = this.variants.get(entry.get('pool_variant'));
      if (entryProduct) this.shape = entryProduct.key;
      if (entryVariant?.source.kind === 'pool' && entryVariant.available && (!entryProduct || entryVariant.source === entryProduct)) {
        this.shape = entryVariant.source.key;
        this.pool = entryVariant;
      }
      this.addEventListener('click', e => this.onClick(e));
      this.addEventListener('change', e => this.onChange(e));
      this.renderPool();
      this.renderPumps();
      this.renderSalt();
      this.renderExtras();
      this.renderSummary();
      this.querySelector('[data-kp-loading]').hidden = true;
      this.querySelector('[data-kp-app]').hidden = false;
    }
    q(selector) { return this.querySelector(selector); }
    t(key) { return this.words[key] || key; }
    esc(value) { return String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
    money(cents) { return new Intl.NumberFormat(this.data.locale, { style: 'currency', currency: this.data.currency }).format(cents / 100); }
    photo(v) {
      const image = v.featured_image || v.source.product.featured_image || v.source.product.images[0];
      const src = typeof image === 'string' ? image : image?.src;
      if (!src) return '';
      const url = new URL(src, location.origin);
      url.searchParams.set('width', '850');
      return url.href;
    }
    rule() { return this.rules.find(r => String(r.variant) === String(this.pool?.id)); }
    source(key) { return this.products.find(p => p.key === key); }
    variantsOf(key) { return [...this.variants.values()].filter(v => v.source.key === key); }
    onClick(e) {
      const button = e.target.closest('button');
      if (!button || !this.contains(button) || this.busy) return;
      if (button.dataset.kpShape) {
        if (this.shape === button.dataset.kpShape) return;
        this.shape = button.dataset.kpShape;
        this.setPool(null);
      }
      if (button.dataset.kpPool) {
        this.setPool(this.variants.get(button.dataset.kpPool));
        this.q(`[data-kp-pool="${button.dataset.kpPool}"]`)?.focus({ preventScroll: true });
      }
      if (button.dataset.kpJump) this.jump(button.dataset.kpJump);
      if (button.hasAttribute('data-kp-add')) this.addPackage();
    }
    onChange(e) {
      const target = e.target;
      if (this.busy) return;
      this.setStatus('');
      if (target.name === this.id + '-pump') {
        this.pump = target.value === 'none' ? null : this.variants.get(target.value);
      }
      if (target.name === this.id + '-salt') {
        if (target.value === 'none') this.extras.delete('salt');
        else this.extras.set('salt', { variant: this.variants.get(target.value), quantity: 1 });
      }
      if (target.dataset.kpExtra) {
        const key = target.dataset.kpExtra;
        const card = target.closest('[data-kp-accessory]');
        const v = this.variants.get(card.querySelector('[data-kp-extra-variant]').value);
        if (target.checked && v?.available) this.extras.set(key, { variant: v, quantity: 1 });
        else this.extras.delete(key);
        this.updateExtraCard(card);
      }
      if (target.hasAttribute('data-kp-extra-variant')) {
        const key = target.closest('[data-kp-accessory]').dataset.kpAccessory;
        const current = this.extras.get(key);
        if (current) current.variant = this.variants.get(target.value);
        this.updateExtraCard(target.closest('[data-kp-accessory]'));
      }
      if (target.hasAttribute('data-kp-quantity')) {
        const key = target.closest('[data-kp-accessory]').dataset.kpAccessory;
        const quantity = Math.max(1, Math.min(10, Math.floor(Number(target.value) || 1)));
        target.value = quantity;
        if (this.extras.has(key)) this.extras.get(key).quantity = quantity;
      }
      this.renderSummary();
    }
    setPool(v) {
      if (v && !v.available) return;
      if (String(v?.id) === String(this.pool?.id)) { this.renderPool(); return; }
      const hadDependent = this.pump || this.extras.has('cover');
      this.pool = v;
      this.pump = null;
      this.extras.delete('cover');
      this.renderPool();
      this.renderPumps();
      this.renderSalt();
      this.renderExtras();
      this.renderSummary();
      this.setStatus(hadDependent ? this.t('pool_changed') : '');
      this.q('[data-kp-announcement]').textContent = v ? `${v.source.label}, ${v.title}. ${this.t('pool_selected')}` : this.t('choose_size');
    }
    renderPool() {
      const variants = this.variantsOf(this.shape);
      this.querySelectorAll('[data-kp-shape]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.kpShape === this.shape)));
      const hero = this.pool || variants[0];
      if (!hero) { this.q('[data-kp-pool-body]').innerHTML = `<p class="kp-empty">${this.esc(this.t('no_pools'))}</p>`; return; }
      this.q('[data-kp-pool-body]').innerHTML = `
        <div class="kp-pool-photo"><img src="${this.esc(this.photo(hero))}" alt="${this.esc(hero.source.label + ' ' + hero.title)}" width="850" height="600" fetchpriority="high"><span class="kp-depth">${this.esc(this.t('depth'))}</span></div>
        <div class="kp-pool-caption"><h3>${this.esc(hero.source.label)}</h3><strong>${this.pool ? this.money(this.pool.price) : this.esc(this.t('from')) + ' ' + this.money(Math.min(...variants.map(v => v.price)))}</strong></div>
        <div class="kp-pool-financing"><p class="affirm-as-low-as" data-kp-affirm-pool data-page-type="product" data-amount="${this.pool ? this.pool.price : Math.min(...variants.map(v => v.price))}" data-affirm-type="logo" data-affirm-color="blue"></p><small>${this.esc(this.t('financing_note'))}</small></div>
        <span class="kp-label" id="${this.id}-sizes">${this.esc(this.t('choose_size'))}</span>
        <div class="kp-sizes" role="group" aria-labelledby="${this.id}-sizes">${variants.map(v => `<button type="button" class="kp-size" data-kp-pool="${v.id}" aria-pressed="${String(v.id === this.pool?.id)}" ${v.available ? '' : 'disabled'}>${this.esc(v.title)}${v.available ? '' : `<small>${this.esc(this.t('sold_out'))}</small>`}</button>`).join('')}</div>
        <p class="kp-included">${this.esc(this.t('included'))}</p>`;
    }
    renderPumps() {
      this.q('[data-kp-pump-empty]').hidden = !!this.pool;
      const container = this.q('[data-kp-pumps]');
      container.hidden = !this.pool;
      if (!this.pool) return;
      const tier = this.rule()?.tier || 'unknown';
      const variants = this.products.filter(p => p.kind === 'pump').flatMap(p => this.variantsOf(p.key));
      const cartridgeOverride = this.rule()?.cartridgeVariant;
      const recommended = variants.filter(v => {
        if (v.source.key === 'cartridge' && cartridgeOverride) return String(v.id) === String(cartridgeOverride);
        return this.pumpTier(v) === tier && tier !== 'unknown';
      });
      const remaining = variants.filter(v => !recommended.includes(v));
      const grouped = this.dataset.pumpColumns === 'grouped';
      const card = v => {
        const fits = recommended.includes(v);
        const details = `<h3>${this.esc(v.source.label)}</h3><p>${this.esc(v.title)}</p><strong>${this.money(v.price)}</strong>`;
        return `<label class="kp-choice"><span class="kp-badge ${fits ? '' : 'is-plain'}">${this.esc(!v.available ? this.t('sold_out') : fits ? this.t('recommended') : this.t('other_option'))}</span><input type="radio" name="${this.id}-pump" value="${v.id}" ${v.id === this.pump?.id ? 'checked' : ''} ${v.available ? '' : 'disabled'}><img src="${this.esc(this.photo(v))}" alt="" width="250" height="180" loading="lazy">${grouped ? `<div class="kp-pump-details">${details}</div>` : details}</label>`;
      };
      const group = (items, name) => items.length ? `<div class="kp-pump-group"><h3 class="kp-pump-group-title">${this.esc(this.t(name === 'recommended' ? 'recommended' : 'other_option'))}</h3><div class="kp-pumps kp-pumps-${name}" style="--kp-other-columns:${Math.min(items.length, 4)}">${items.map(card).join('')}</div></div>` : '';
      container.innerHTML = `<p class="kp-hint">${this.esc(this.t(tier === 'unknown' ? 'round_help' : tier === 'small' ? 'small_help' : 'large_help'))}</p>
        <label class="kp-choice kp-skip"><input type="radio" name="${this.id}-pump" value="none" ${!this.pump ? 'checked' : ''}><b>${this.esc(this.t('skip_pump'))}</b><small>${this.esc(this.t('skip_pump_help'))}</small></label>
        ${grouped ? group(recommended, 'recommended') + group(remaining, 'other') : `<div class="kp-pumps">${[...recommended, ...remaining].map(card).join('')}</div>`}`;
    }
    pumpTier(v) {
      return this.data.pumpTiers[String(v.id)] || 'unknown';
    }
    renderSalt() {
      const variant = this.variantsOf('salt').find(v => v.available) || this.variantsOf('salt')[0];
      const container = this.q('[data-kp-salt]');
      if (!variant) { container.innerHTML = ''; return; }
      const selected = this.extras.has('salt');
      container.innerHTML = `${!this.pool ? `<p class="kp-hint">${this.esc(this.t('salt_empty'))}</p>` : ''}
        <label class="kp-choice kp-skip"><input type="radio" name="${this.id}-salt" value="none" ${selected ? '' : 'checked'} ${this.pool ? '' : 'disabled'}><b>${this.esc(this.t('salt_skip'))}</b><small>${this.esc(this.t('salt_skip_help'))}</small></label>
        <label class="kp-choice kp-salt-choice"><input type="radio" name="${this.id}-salt" value="${variant.id}" ${selected ? 'checked' : ''} ${this.pool && variant.available ? '' : 'disabled'}><div class="kp-salt-image"><img src="${this.esc(this.photo(variant))}" alt="" width="250" height="200" loading="lazy"></div><div><span class="kp-badge">${this.esc(variant.available ? this.t('salt_badge') : this.t('sold_out'))}</span><h3>${this.esc(this.t('salt_add'))}</h3><p><b>${this.esc(variant.source.label)}</b><br>${this.esc(variant.source.description)}</p><strong>+ ${this.money(variant.price)}</strong></div></label>`;
    }
    eligibleExtras(key) {
      if (key !== 'cover') return this.variantsOf(key);
      const label = this.rule()?.cover;
      return label ? this.variantsOf(key).filter(v => v.option1 === label) : [];
    }
    renderExtras() {
      this.q('[data-kp-extra-empty]').hidden = !!this.pool;
      const container = this.q('[data-kp-extras]');
      container.hidden = !this.pool;
      if (!this.pool) return;
      container.innerHTML = this.products.filter(p => p.kind === 'accessory').map(p => {
        const variants = this.eligibleExtras(p.key);
        const stored = this.extras.get(p.key);
        const v = stored?.variant || variants.find(v => v.available) || variants[0];
        const available = variants.some(v => v.available);
        const photo = v || this.variantsOf(p.key)[0];
        return `<article class="kp-accessory ${stored ? 'is-selected' : ''} ${available ? '' : 'is-disabled'}" data-kp-accessory="${p.key}"><img src="${this.esc(this.photo(photo))}" alt="" width="100" height="100" loading="lazy"><div><div class="kp-accessory-heading"><label for="${this.id}-${p.key}"><input type="checkbox" id="${this.id}-${p.key}" data-kp-extra="${p.key}" ${stored ? 'checked' : ''} ${available ? '' : 'disabled'}>${this.esc(p.label)}</label><strong data-kp-extra-price>${v ? this.money(v.price) : ''}</strong></div><p>${this.esc(p.description)}</p>${!available ? `<p>${this.esc(this.t(variants.length ? 'sold_out' : 'no_cover'))}</p>` : ''}<div class="kp-controls"><div ${variants.length < 2 ? 'hidden' : ''}><label for="${this.id}-${p.key}-variant">${this.esc(this.t(p.key === 'cover' ? 'cover_size' : 'option'))}</label><select id="${this.id}-${p.key}-variant" data-kp-extra-variant ${available ? '' : 'disabled'}>${variants.map(option => `<option value="${option.id}" ${option.id === v?.id ? 'selected' : ''} ${option.available ? '' : 'disabled'}>${this.esc(p.key === 'cover' ? option.option2 : option.title)}${option.available ? '' : ' — ' + this.esc(this.t('sold_out'))}</option>`).join('')}</select></div><div class="kp-quantity" ${stored ? '' : 'hidden'}><label for="${this.id}-${p.key}-qty">${this.esc(this.t('quantity'))}</label><input type="number" id="${this.id}-${p.key}-qty" min="1" max="10" step="1" value="${stored?.quantity || 1}" data-kp-quantity></div></div></div></article>`;
      }).join('');
    }
    updateExtraCard(card) {
      const key = card.dataset.kpAccessory;
      const selected = this.extras.has(key);
      const variant = this.variants.get(card.querySelector('[data-kp-extra-variant]').value);
      card.classList.toggle('is-selected', selected);
      card.querySelector('.kp-quantity').hidden = !selected;
      if (!selected) card.querySelector('[data-kp-quantity]').value = 1;
      card.querySelector('[data-kp-extra-price]').textContent = variant ? this.money(variant.price) : '';
    }
    lines() {
      if (!this.pool) return [];
      return [this.pool && { variant: this.pool, quantity: 1 }, this.pump && { variant: this.pump, quantity: 1 }, ...this.extras.values()].filter(Boolean);
    }
    renderSummary() {
      const lines = this.lines();
      const total = lines.reduce((sum, line) => sum + line.variant.price * line.quantity, 0);
      this.q('[data-kp-summary-empty]').hidden = !!this.pool;
      this.q('[data-kp-summary-list]').innerHTML = lines.map(({ variant: v, quantity }) => `<li><div>${this.esc(v.source.label)}${quantity > 1 ? ' × ' + quantity : ''}<small>${v.title === 'Default Title' ? '' : this.esc(v.title)}</small></div><strong>${this.money(v.price * quantity)}</strong></li>`).join('');
      if (this.pool && !this.pump) this.q('[data-kp-summary-list]').insertAdjacentHTML('beforeend', `<li><div>${this.esc(this.t('pump_summary'))}<small>${this.esc(this.t('not_added'))}</small></div><strong>—</strong></li>`);
      this.querySelectorAll('[data-kp-total]').forEach(el => el.textContent = this.money(total));
      this.q('[data-kp-saltwater-badge]').hidden = !this.pool || !this.extras.has('salt');
      this.q('[data-kp-financing]').hidden = !this.pool;
      const financing = this.q('[data-kp-affirm-total]');
      if (financing.dataset.amount !== String(total)) {
        financing.dataset.amount = String(total);
        financing.replaceChildren();
      }
      this.refreshAffirm();
      this.querySelectorAll('[data-kp-add]').forEach(button => {
        button.disabled = !this.pool || !lines.every(l => l.variant.available) || this.busy || this.submitted;
        button.textContent = this.busy ? this.t('adding') : this.submitted ? this.t(this.cartUncertain ? 'review_cart' : 'added') : this.pool ? this.t('add_package') : this.t('choose_pool_first');
      });
    }
    refreshAffirm() {
      clearTimeout(this.affirmTimer);
      let attempts = 0;
      const refresh = () => {
        if (!this.isConnected) return;
        if (window.affirm?.ui?.ready) {
          window.affirm.ui.ready(() => { if (this.isConnected) window.affirm.ui.refresh(); });
        } else if (++attempts < 20) this.affirmTimer = setTimeout(refresh, 500);
      };
      this.affirmTimer = setTimeout(refresh, 180);
    }
    disconnectedCallback() { clearTimeout(this.affirmTimer); }
    setStatus(message, error = false) {
      const el = this.q('[data-kp-status]');
      el.textContent = message;
      el.classList.toggle('is-error', error);
      if (error) { this.jump('summary'); el.focus({ preventScroll: true }); }
    }
    jump(section) {
      const el = this.q(`[data-kp-section="${section}"]`);
      el.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      el.focus({ preventScroll: true });
    }
    async readJson(url, options = {}) {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: AbortSignal.timeout(20000) });
      const body = await response.json();
      if (!response.ok) throw new Error(typeof body.description === 'string' ? body.description : this.t('cart_error'));
      return body;
    }
    async addPackage() {
      if (!this.pool || this.busy || this.submitted) return;
      this.busy = true;
      this.q('.kp-steps').inert = true;
      this.renderSummary();
      this.setStatus('');
      const lines = this.lines();
      const root = this.data.root;
      const packageId = crypto.randomUUID();
      let posted = false;
      try {
        const handles = [...new Set(lines.map(l => l.variant.source.product.handle))];
        const fresh = await Promise.all(handles.map(handle => this.readJson(`${root}products/${encodeURIComponent(handle)}.js`)));
        let changed = false;
        for (const line of lines) {
          const current = fresh.flatMap(p => p.variants).find(v => String(v.id) === String(line.variant.id));
          if (!current || !current.available) { line.variant.available = false; changed = true; }
          else if (current.price !== line.variant.price) { line.variant.price = current.price; changed = true; }
        }
        if (changed) {
          this.renderPool(); this.renderPumps(); this.renderSalt(); this.renderExtras();
          throw new Error(this.t('catalog_changed'));
        }
        posted = true;
        await this.readJson(this.data.cartAdd + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: lines.map(({ variant, quantity }) => ({ id: variant.id, quantity, properties: { _kona_package: packageId } })) })
        });
        this.submitted = true;
        this.setStatus(this.t('added_help'));
        this.q('[data-kp-cart-link]').hidden = false;
        location.assign(this.data.cart);
      } catch (error) {
        if (posted) {
          this.submitted = true;
          this.cartUncertain = true;
          this.q('[data-kp-cart-link]').hidden = false;
          this.setStatus(`${error.message} ${this.t('check_cart')}`, true);
        } else this.setStatus(error.message || this.t('cart_error'), true);
      } finally {
        this.busy = false;
        this.q('.kp-steps').inert = false;
        this.renderSummary();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
